import { useEffect, useRef, useState } from 'react';
import { GridContainer, MainButton } from '../../global';
import { Box, BoxInfomation, BoxLogos,SeparatorImage,
  DifferentialsSection,SectionTitle,DifferentialsGrid,DifferentialItem, 
  BoxServicos, ContainerCA, ContainerSE, ContentForm, HeroContainer,
   TransparentButton,StepsSection,StepsGrid,StepCard,  StepNumberIcon, TwoColumns } from './style'; //
import { useOrcamentoContext } from '../../contexts/orcamentoContext';
import { useNavigate } from 'react-router-dom';
import HeroCarousel from '../../components/Carousel';
import WhatsAppButton from '../../components/WhatsAppButton';



function Home() {
  const { handleSubmit, loading, userData } = useOrcamentoContext();
  const navigate = useNavigate()

  const targetSectionRef = useRef(null);

  // Função para rolar até a seção de destino
  const handleScroll = () => {
    // Verifica se a referência está disponível
    if (targetSectionRef.current) {
      targetSectionRef.current.scrollIntoView({
        behavior: 'smooth', // Define o comportamento de scroll suave
        block: 'start',     // Faz o scroll até o topo da seção
      });
    }
  };

  const [formData, setFormData] = useState({
    client_name: "",
    client_telefone: "",
    client_email: "",
    zip: "",
    potencia_pico: "",
    estrutura_fixacao: "",
    marca_inversor: "",
    marca_modulo: "",
    rede_ca: "",
    state_id: "",
    tensao_rede_ca: "",
    // string_box: false, // <--- STRING_BOX COMENTADO NA INICIALIZAÇÃO DO ESTADO
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Esta linha ainda funciona para outros checkboxes, se houver.
                                                      // Se string_box for o único, a parte "type === 'checkbox'" não será mais usada por ele.
    }));
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;

    let onlyNumbers = value.replace(/\D/g, '');

    if (name === 'client_telefone') {
      if (onlyNumbers.length <= 10) {
        onlyNumbers = onlyNumbers.replace(/(\d{2})(\d{0,4})(\d{0,4})/, (_, p1, p2, p3) =>
          p3 ? `(${p1}) ${p2}-${p3}` : p2 ? `(${p1}) ${p2}` : `(${p1}`
        );
      } else {
        onlyNumbers = onlyNumbers.replace(/(\d{2})(\d{0,5})(\d{0,4})/, (_, p1, p2, p3) =>
          p3 ? `(${p1}) ${p2}-${p3}` : p2 ? `(${p1}) ${p2}` : `(${p1}`
        );
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: onlyNumbers,
    }));
  };

  const validateEmail = (e) => {
    const { value } = e.target;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(value)) {
      alert("O email fornecido é inválido");
    }
  };



  const handleCepChange = async (e) => {
    const value = e.target.value;
    const cepLimpo = value.replace(/\D/g, ''); // Limpa o CEP para conter apenas números

    setFormData((prev) => ({
      ...prev,
      zip: value, // Mantém o valor original com máscara no campo, se desejado, ou use cepLimpo
    }));

    if (cepLimpo.length === 8) { // Verifica o CEP limpo
      try {
        // Usa o cepLimpo na URL da API
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();

        if (data.erro) {
          alert("CEP não encontrado");
          // Considerar limpar os campos de endereço ou o campo CEP se não encontrado
          // e.target.value = ""; // Cuidado ao modificar e.target.value diretamente se o campo for controlado
        } else {
          setFormData((prev) => ({
            ...prev,
            state_id: data?.uf,
            // zip: data?.cep, // Decide se quer atualizar o formData.zip com o CEP retornado pela API (sem máscara)
          }));
        }
      } catch (error) {
        console.error("Erro ao buscar o CEP:", error);
        
      }
    }
  };

  // const ValidNumberCep = (e) => {
  //   const input = e.target; 
  //   const value = input.value;

  //   if (value.length !== 8) {
  //     alert("Digite todos os números do CEP (8 caracteres)");
  //     input.value = "";
  //     return false;
  //   }

  //   return true;
  // };

  const onSubmit = (e) => {
    e.preventDefault();
    // Como string_box foi removido do estado formData, ele não será enviado
    // ou será enviado como undefined se o backend/contexto o esperar explicitamente.
    // Se o seu handleSubmit no contexto ainda espera `formData.string_box`,
    // você precisará garantir que ele lide com `undefined` ou remova a referência a `string_box` lá também.
    handleSubmit(formData)
    navigate("/orcamento")
  };

  useEffect(() => {
    if (userData) {
      // Se userData (do contexto) puder conter string_box,
      // e você não quiser mais usá-lo, pode-se filtrar aqui também.
      // Ex: const { string_box, ...restUserData } = userData; setFormData(restUserData);
      // Mas, como string_box foi removido da inicialização de formData,
      // ele não será incluído a menos que userData o force.
      setFormData(prevFormData => ({ ...prevFormData, ...userData }));
    }
  }, [userData])


  return (
    <div style={{ width: "100%", overflow: "auto", position: "relative" }}>
      <HeroCarousel />

      <SeparatorImage src="/placa.png" alt="Painéis solares" />

      <DifferentialsSection>
        <GridContainer>
          <SectionTitle>DIFERENCIAIS RENOVERA</SectionTitle>
          <DifferentialsGrid>

            <DifferentialItem>
              <img src="/icone/icone-aperto.png" alt="Ícone de aperto de mãos" />
              <p>Atendimento humanizado</p>
            </DifferentialItem>
            
            <DifferentialItem>
              <img src="/icone/icone-preco.png" alt="Ícone de preço" />
              <p>Melhor condições do mercado</p>
            </DifferentialItem>
            
            
            
            <DifferentialItem>
              <img src="/icone/icone-estoque.png" alt="Ícone de caixa de estoque" />
              <p>Estoque de grandes distribuidores e melhores marcas</p>
            </DifferentialItem>
            
            <DifferentialItem>
              <img src="/icone/icone-chave.png" alt="Ícone de ferramenta" />
              <p>Consultoria técnica e jurídica para casos reprovados por inversão de fluxo</p>
            </DifferentialItem>

          </DifferentialsGrid>
        </GridContainer>
      </DifferentialsSection>

      <StepsSection>
        <GridContainer>
          <StepsGrid>

            <StepCard>
              <StepNumberIcon src="/icone/icone-1.png" />
              <h3>SOLICITE SEU ORÇAMENTO COM FACILIDADE</h3>
              <p>Preencha os dados do seu projeto no site em poucos cliques. Unimos tecnologia inteligente e atendimento humanizado para simplificar sua jornada de compra.</p>
            </StepCard>

            <StepCard>
               <StepNumberIcon src="/icone/icone-2.png" />
              <h3>RECEBA AS MELHORES PROPOSTAS DO MERCADO</h3>
              <p>Trabalhamos com grandes distribuidores e as melhores marcas do mercado para te apresentar condições diferenciadas. Tudo de forma simples, rápida e com total transparência.</p>
            </StepCard>

            <StepCard>
              <StepNumberIcon src="/icone/icone-3.png" />
              <h3>AJUSTE SUA PROPOSTA DA FORMA QUE MELHOR LHE ATENDE</h3>
              <p>Você pode revisar os itens, trocar marcas, ajustar quantidades e personalizar o kit conforme sua necessidade, direto pelo whatsapp, com nosso time comercial.</p>
            </StepCard>

            <StepCard>
              <StepNumberIcon src="/icone/icone-4.png" />
              <h3>FINALIZE COM SEGURANÇA E SIGA COM A GENTE</h3>
              <p>Acompanhe cada etapa do pedido com a nossa equipe comercial. Cuidamos de todo o pós venda até a entrega dos seus equipamentos.</p>
            </StepCard>
            
          </StepsGrid>
        </GridContainer>
      </StepsSection>
      
      <div id="orcamento-form" ref={targetSectionRef} style={{ backgroundColor: '#f9f9f9', paddingTop: '60px', paddingBottom: '60px' }}>
        <GridContainer>
          <TwoColumns>
            <BoxInfomation className='heroheader' colorTitle="#02391E" sizeTitle="32px" colorText="#424242">
              <h3>Encontre as melhores condições para o seu kit fotovoltaico</h3>
              <p>A Renovera reúne o estoque dos equipamentos fotovoltaicos dos principais distribuidores do mercado, com o melhor preço.</p>
              <p>Preencha os dados ao lado e gere seu orçamento com apenas 1 clique. Fazemos a comparação com +20 distribuidores e entregamos as melhores opções para o seu negócio.</p>
              <p>Caso você já tenha uma proposta e queira melhorar a negociação, clique aqui e insira sua proposta atual.</p>
            </BoxInfomation>
            <ContentForm>
              <form onSubmit={onSubmit}>
                <label>
                  Seu nome*
                  <input type="text" name="client_name" placeholder="Ex: José Almeida" value={formData.client_name || ""} onChange={handleChange} required />
                </label>
                <label>
                  Telefone com DDD
                  <input type="text" minLength={14} maxLength={15} name="client_telefone" placeholder="(00) 00000-0000" value={formData.client_telefone || ""} onChange={handlePhoneChange} required />
                </label>
                <label>
                  E-mail*
                  <input type="text" name="client_email" placeholder="Ex: jose@email.com.br" value={formData.client_email || ""} onChange={handleChange} onBlur={validateEmail} required />
                </label>
                <label>
                  CEP de instalação do projeto*
                  <input type="text" name="zip" minLength={8} maxLength={8} placeholder="Ex: 37000-999" value={formData.zip || ""} onChange={handleCepChange} required />
                </label>
                <label>
                  Potência pico*
                  <input type="text" name="potencia_pico" placeholder="Ex: 100" value={formData.potencia_pico || ""} onChange={handleChange} required />
                </label>
                <label>
                  Estrutura de fixação*
                  <select name="estrutura_fixacao" type="text" id="estrutura_fixacao" value={formData.estrutura_fixacao || ""} required onChange={handleChange}> {/* Removido required="" que é inválido */}
                    <option value="">Selecione</option>
                    <option value="sem_estrutura">Sem estrutura</option>
                    <option value="fibromadeira">Fibromadeira</option>
                    <option value="fibrometal">Fibrometal</option>
                    <option value="fibrocimento">Fibrocimento</option>
                    <option value="colonialceramico">Colonial / Cerâmico</option>
                    <option value="metalicoelevado">Metálico Elevado</option>
                    <option value="metalico">Metálico</option>
                    <option value="laje">Laje</option>
                    <option value="solo">Solo</option>
                  </select>
                </label>

                <label>
                  Rede CA*
                  <select name="rede_ca" type="text" id="rede_ca" value={formData.rede_ca || ""} required onChange={handleChange} > {/* Removido required="" que é inválido */}
                    <option value="">Selecione</option>
                    <option value="mono_127">Monofásico 127V</option>
                    <option value="mono_220">Monofásico 220V</option>
                    <option value="bi_220">Bifásico 220V</option>
                    <option value="tri_220">Trifásico 220V</option>
                    <option value="tri_380">Trifásico 380V</option>
                    <option value="acima">Acima de 380V</option>
                  </select>
                </label>
                {/* // <--- STRING_BOX COMENTADO NO JSX
                <label>
                  <input
                    type="checkbox"
                    name="string_box"
                    checked={formData.string_box || false} 
                    onChange={handleChange} 
                  />
                  Desejo incluir a StringBox
                </label>
                */}
                <button type="submit" disabled={loading}>
                  {loading ? "Buscando..." : "Buscar"}
                </button>
              </form>
                </ContentForm>
          </TwoColumns>
        </GridContainer>
      </div>
      <ContainerSE style={{ background: "url(/bg-servicos.png)" }}>
        <GridContainer>
          <TwoColumns>
            <BoxInfomation colorTitle="#ffffff" sizeTitle="28px" colorText="#ffffff">
              <h3>Estamos prontos para fazer os melhores negócios fotovoltaicos. E você?</h3>
              <TransparentButton textColor="#ffffff" hoverColor="#056731" onClick={handleScroll}>Faça seu orçamento agora</TransparentButton>
            </BoxInfomation>
            <BoxServicos>
              <Box>
                <img src="/icon-praticidade.png" alt="Ícone Praticidade" /> 
                <strong>Praticidade</strong>
              </Box>
              <Box>
                <img src="/icon-economia.png" alt="Ícone Economia" /> 
                <strong>Economia</strong>
              </Box>
              <Box>
                <img src="/icon-tecnologia.png" alt="Ícone Tecnologia" /> 
                <strong>Tecnologia</strong>
              </Box>
            </BoxServicos>
          </TwoColumns>
        </GridContainer>
      </ContainerSE>
      <GridContainer>
        <TwoColumns>
          <BoxInfomation className="financeiro" colorTitle="#02391E" sizeTitle="40px" colorText="#424242">
            <h3>Conheça nossos parceiros</h3>
            <p>Reunimos, em nossa plataforma, o estoque dos melhores distribuidores de equipamentos fotovoltaicos do mercado para oferecer a você, integrador, uma experiência incrível.</p>

            <p>Aqui, você encontra todos os produtos de que precisa, com o melhor preço e as condições que atendem às suas necessidades.</p>
            <TransparentButton textColor="#056731" hoverColor="#ffffff" onClick={handleScroll}>Faça seu orçamento agora</TransparentButton>
          </BoxInfomation>
          <BoxLogos>

            <img style={{ width: "80%" }} src="/NOSSOS PARCEIROS 2025.png" alt="Nossos Parceiros" /> {/* Adicionado alt */}

          </BoxLogos>
        </TwoColumns>
      </GridContainer>
      <ContainerCA style={{ background: "url(/bg-compre-agora.png)" }}>
        <GridContainer>
          <p>Na Renovera, você insere os dados do projeto a qualquer momento, direto no site, e, além de gerar seu orçamento de acordo com a busca do nosso sistema, pode fazer as revisões que desejar, efetuar a compra e aguardar a chegada dos equipamentos no local da instalação.</p>
          <MainButton href="https://www.renovera.com.br/cadastro">Compre agora</MainButton>
        </GridContainer>
      </ContainerCA>
      {/* <GridContainer> So um exemplo para teste ! pode ser alterado depois
            <TwoColumns>npm
              <BoxLogos className="logos-financeiro-desktop">
                <h4>Agentes financeiros</h4>
                <img src="/logos-financeiras.png" />
              </BoxLogos>
              <BoxInfomation className="financeiro" colorTitle="#02391E" sizeTitle="40px" colorText="#424242">
                <h3>Consulte o crédito conosco</h3>
                <p>Só a Renovera consegue taxas extremamente atrativas para o crédito do seu projeto!</p>

                <p>Ao adquirir o equipamento com a gente, você terá acesso ao monitoramento exclusivo da Renovera, que aumenta as chances de conseguir a aprovação do crédito e garante as melhores taxas.</p>

                <p>Nossos parceiros financeiros estão prontos para alavancar o seu negócio!</p>
                <TransparentButton textColor="#056731" hoverColor="#ffffff" onClick={handleScroll}>Faça seu orçamento agora</TransparentButton>
              </BoxInfomation>
              <BoxLogos className="logos-financeiro-mobile">
                <h4>Agentes financeiros</h4>
                <img src="/logos-financeiras.png" />
              </BoxLogos>
            </TwoColumns>
          </GridContainer> */}
          <WhatsAppButton />
    </div>
  )
}

export default Home